// React
import React from 'react';
import PropTypes from 'prop-types';

import { SettingsTable } from '@cybs-ui/components/lib/table';

import getHeaders from './getHeaders';
import getRows from './getRows';

const UploadTable = ({
  i18n,
  handleDeleteRow,
  showStatus,
  rows
}) => (
    <SettingsTable
      dataTest="file-upload"
      headers={getHeaders(i18n.headers, showStatus)}
      onCellChange={(value, cell, row) =>
        handleDeleteRow(value, cell, row)
      }
      rows={getRows(rows, i18n.noFilesSelected, showStatus, i18n)}
      caption={i18n.caption || 'Table caption'}
    />
  );

UploadTable.displayName = 'UploadTable';

UploadTable.propTypes = {
  i18n: PropTypes.shape({
    noFilesSelected: PropTypes.string,
    tooltipLabel: PropTypes.string,
    caption: PropTypes.string,
    headers: PropTypes.shape({
      fileName: PropTypes.string,
      fileSize: PropTypes.string,
      status: PropTypes.string,
      remove: PropTypes.string
    })
  }),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      error: PropTypes.bool,
      // This is a File object below
      file: PropTypes.any,
      fileName: PropTypes.string,
      fileSize: PropTypes.string
    })
  ),
  handleDeleteRow: PropTypes.func,
  /**
    * If `true`, the table will show a status.
    */
  showStatus: PropTypes.bool
};

UploadTable.defaultProps = {
  i18n: {
    noFilesSelected: 'No files Uploaded.',
    tooltipLabel: 'Remove',
    headers: {
      fileName: 'File Name',
      fileSize: 'File Size',
      status: 'Status',
      remove: 'Remove'
    }
  },
  rows: [],
  handleDeleteRow: () => { },
  showStatus: true
};

export default UploadTable;
